import React, { useState } from "react";
import "./style.scss";
import Workdetail from "../workdetail/Workdetail";
import WorkDetailNew from "../workdetailnew/WorkDetailNew";
import { CiSearch } from "react-icons/ci";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
const SearchComp = () => {
  const [toggle, setToggle] = useState(false);
  const [villagename, setVillageName] = useState("");
  const [works, setWorks] = useState([]);
  const [villageNameList, setVillageNameList] = useState([]);
  const fetchVillages = async () => {
    try {
      const response = await axios.get(
        `https://backend.sambhajipatilnilangekar.com/api/villageworks/villagename/?village_name=${villagename}`
      );
      const villages = response.data.map((village) => village.village_name);
      const uniqueVillages = [...new Set(villages)];
      setVillageNameList(uniqueVillages);
      return response.data;
    } catch (err) {
      console.log(err);
      toast.error("An error occurred while fetching villages.");
    }
  };

  const fetchHandler = async (e) => {
    e.preventDefault();
    const fetchedWorks = await fetchVillages();
    setWorks(fetchedWorks);
    if (fetchedWorks.length === 0) {
      toast.error("गाव उपलब्ध नाही");
      setToggle(false);
    } else {
      setToggle(true);
    }
  };
  return (
    <>
      <div className="newsearch-parent parent">
        <div className="newsearch-comp comp">
          <form className="newsearch-input-box" onSubmit={fetchHandler}>
            <input
              type="text"
              className="newsearch-input"
              placeholder={`आपले गाव शोधा`}
              onChange={(e) => setVillageName(e.target.value)}
              required
            />
            <button className="newsearch-btn" type="submit">
              शोधा
            </button>
          </form>
        </div>
      </div>
      {toggle && <WorkDetailNew works={works} list={villageNameList} />}

      <Toaster position="top-center" reverseOrder={false} />
    </>
  );
};

export default SearchComp;
